import React, {useState, useEffect} from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../global/components/Constants';
import './components/presentation_styles.css';
import PresentationHeader from './components/PresentationHeader';
import PresentationPage from './components/PresentationPage';
import PresentationContPage  from './components/PresentationContPage';

function Presentation() {

    const [topic, setTopic] = useState(null);
    const [component, setComponent] = useState({});
    const [topicLoading, setTopicLoading] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    const params = new URLSearchParams(window.location.search);
    const { code } = useParams();
    const { compSlug } = useParams();
    const mode = params.get("mode");

    useEffect(()=>{
        loadTopic();
        loadComponent();
        document.body.style.overflow = 'hidden';
    }, []);

    function loadTopic(){
        setTopicLoading(true);
        axios({
            method: 'get',
            url: API_URL + `topic/topic_by_slug?slug=${code}`,
        }).then((respose)=>{
            const obj = respose.data;
            if(obj.Success){
                setTopic(obj.Data);
            }
            setTopicLoading(false);
        });
    }

    function loadComponent(){
        const components = localStorage.getItem('components');
        if(components){
            const data = JSON.parse(components);
            const obj = data.find(x => x.Slug == compSlug);
            setComponent(obj);
        }
    }

    const styles = {
        page:{
            background: '#fff',
            minHeight: height,
            marginBottom: 60
        },
        body:{
            display: 'flex',
            justifyContent: 'center',
            flex: 1,
            position: 'relative'
        },
        loading:{
            paddingTop:100
        },
    }

    if(topicLoading){
        return (
            <div style = {styles.loading}>
                <div className='container'>
                    Loading ...
                </div>
            </div>
        )
    }else{
        if(component){
            return (
                <section style={styles.page}>
                    <PresentationHeader />
                    <div className='container topic-styles'>
                        {(component.ComponentType == "container")?
                            <PresentationContPage topic={topic} obj={component} edit={(mode=="edit")? true: false} />:
                            <PresentationPage topic={topic} obj={component} edit={(mode=="edit")? true: false} />
                        }
                    </div>
                </section>
            )
        }
    }
    
}

export default Presentation;